import React from 'react';

export const PrivacyPolicyScreen = () => {
  return (
    <div className="min-h-screen bg-white" data-testid="privacy-policy-page">
      <div className="max-w-2xl mx-auto px-4 py-8">
        <h1 className="text-2xl font-bold text-gray-900 mb-6">Privacy Policy</h1>
        <p className="text-sm text-gray-500 mb-6">Last updated: April 15, 2025</p>

        <div className="space-y-6 text-gray-700 text-sm leading-relaxed">
          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-2">1. Introduction</h2>
            <p>
              SellGen AI ("we", "our", or "us") is committed to protecting your privacy. 
              This Privacy Policy explains how we collect, use, and safeguard your information 
              when you use our mobile application and services.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-2">2. Information We Collect</h2>
            <p className="mb-2">We collect the following types of information:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li><strong>Phone Number:</strong> Used for account registration and login via OTP verification.</li>
              <li><strong>Product Images:</strong> Photos you upload for AI-powered product listing generation. These images are processed to generate titles, descriptions, and tags.</li>
              <li><strong>Email Address (Optional):</strong> If you choose to email CSV export files to yourself.</li>
              <li><strong>Product Data:</strong> Titles, descriptions, tags, and pricing information generated or entered by you.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-2">3. How We Use Your Information</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>To provide and maintain our service</li>
              <li>To authenticate your identity via OTP login</li>
              <li>To generate AI-powered product listings from your uploaded images</li>
              <li>To export product data as CSV files for e-commerce platforms</li>
              <li>To send CSV files to your email when requested</li>
              <li>To generate marketing content for your products</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-2">4. Third-Party Services</h2>
            <p className="mb-2">We use the following third-party services to provide our features:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li><strong>OpenAI:</strong> Product images are sent to OpenAI's API for AI analysis and content generation. OpenAI's privacy policy applies to this data processing.</li>
              <li><strong>Resend:</strong> Used for email delivery when you request CSV exports via email.</li>
              <li><strong>Shopify:</strong> If you connect your Shopify store, product data is sent to Shopify's API for direct publishing.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-2">5. Data Storage and Security</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>All data is transmitted over secure HTTPS connections.</li>
              <li>Your data is stored in secure, encrypted databases.</li>
              <li>We do not sell your personal information to any third party.</li>
              <li>Product images are stored securely and used only for generating your listings.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-2">6. Data Retention and Deletion</h2>
            <p>
              We retain your data for as long as your account is active. You may request 
              deletion of your account and all associated data at any time by contacting us. 
              Upon receiving a deletion request, we will remove your personal data within 30 days.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-2">7. Children's Privacy</h2>
            <p>
              SellGen AI is not intended for use by children under the age of 18. We do not 
              knowingly collect personal information from children under 18. If we become 
              aware that we have collected data from a child under 18, we will take steps 
              to delete that information.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-2">8. Your Rights</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>Access and review your personal data</li>
              <li>Request correction of inaccurate data</li>
              <li>Request deletion of your data</li>
              <li>Opt out of email communications</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-2">9. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. We will notify you of 
              any changes by posting the new Privacy Policy on this page and updating the 
              "Last updated" date.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-2">10. Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy or wish to request data 
              deletion, please contact us at:
            </p>
            <p className="mt-2 font-medium">support@sellgen.online</p>
          </section>
        </div>

        <div className="mt-8 pt-6 border-t border-gray-200 text-center text-xs text-gray-400">
          &copy; 2025 SellGen AI. All rights reserved.
        </div>
      </div>
    </div>
  );
};
